import "./index.css";

import { BubbleApp } from "./bubble/BubbleApp";

export function App() {
  return <BubbleApp />;
}

export default App;
